import {LOAD_CRUCESINTERNACIONALES_SUCCESS, ICruceInternacional} from "../types/cruceInternacionalActionTypes";
import useCommonApi from "../../api/useCommonApi";

const apiSource = useCommonApi();

export function loadCrucesInternacionales() {
    return function (dispatch) {
        return apiSource.obtener<ICruceInternacional[]>("cruce-internacional/active")
            .then((crucesInternacionales: ICruceInternacional[]) => {
                dispatch({type: LOAD_CRUCESINTERNACIONALES_SUCCESS, crucesInternacionales})
            })
            .catch(error => {
               // throw error;
            })
    }
}
